import React from 'react';
import { Global } from '@emotion/react';
import { ThemeProvider } from '@emotion/react';
import globalStyles from './globalStyles';
import size from '../constants/size';
import GlobalContext from './GlobalContext';
import { kbbTheme } from '@argo/themes';
const Theme = _ref => {
  let {
    children,
    theme = kbbTheme,
    gridDebugger,
    fontFace,
    principles,
    uiElements,
    patterns,
    maxWidth = size.contentMaxWidth,
    gridConfig = {
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      max: 12,
      smRail: 12,
      mdRail: 12,
      lgRail: 12,
      xlRail: 12,
      maxRail: 12
    }
  } = _ref;
  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(GlobalContext.Provider, {
    value: {
      maxWidth,
      gridConfig
    }
  }, React.createElement(Global, {
    styles: globalStyles({
      fontFace,
      principles,
      uiElements,
      patterns,
      theme
    })
  }), gridDebugger, children));
};
Theme.displayName = 'Theme';
export default Theme;
//# sourceMappingURL=Theme.js.map